import React, {useEffect, useState} from "react";
import styles from './NavigationBar.module.css'
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import {GiHamburgerMenu} from "react-icons/gi";
import {Stack} from "@mui/material";

import { Link, useNavigate, useLocation } from "react-router-dom";

const NavigationLinks = ({ className }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [hashToScroll, setHashToScroll] = useState(null);

    useEffect(() => {
        if (hashToScroll) {
            const targetElement = document.getElementById(hashToScroll);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
                setHashToScroll(null); // Reset after scrolling
            }
        }
    }, [location, hashToScroll]);

    const handleNavigateToHash = (path, hash) => {
        // check if the path is same or not
        if (location.pathname !== path) {
            setHashToScroll(hash);
            navigate(path);
        } else {
            // If already on the same page, scroll directly
            const targetElement = document.getElementById(hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
            }
        }
    };

    return (
        <div className={`${styles.links} flex flex-col md:block ${className}`}>

            <span onClick={() => handleNavigateToHash("/", "Home")}>Home</span>
            <Link to="/results">Results</Link>
            <span onClick={() => handleNavigateToHash("/", "About")}>About</span>
            <span onClick={() => handleNavigateToHash("/", "Contact")}>Contact</span>
        </div>
    );
};

function NavigationBar() {
    const [open, setOpen] = useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const DrawerList = (
        <Box sx={{width: 250}} role="presentation" onClick={toggleDrawer(false)}>
            <Stack direction="horizontal" gap={2} className="px-3 py-6  border-bottom bg-tertiary">
                <Link to={'/'}>
                    <h4 className="text-tertiary font-bold text-base">Sachira Dilanka - Science</h4>
                </Link>
            </Stack>
            <NavigationLinks/>
        </Box>
    );


    return (
        <div className="bg-tertiary fixed left-0 right-0 top-0 px-6 md:px-3 z-50">
            <div className="container mx-auto flex justify-between py-6">
                <div>
                    <Link to={'/'}>
                        <h4 className="text-white font-bold text-xl">Sachira Dilanka - Science</h4>
                    </Link>
                </div>
                <NavigationLinks className="hidden md:block"/>
                <div className="md:hidden" onClick={toggleDrawer(true)}>
                    <GiHamburgerMenu size={25} color="white"/>
                </div>
                <Drawer open={open} onClose={toggleDrawer(false)}>
                {DrawerList}
      </Drawer>
      </div>
    </div>
  );
}

export default NavigationBar;
